import React, { useEffect, useState } from "react";
import "./UserOffers.css";
import { API } from "../../constants/Api";
import { format } from "date-fns";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
function UserOffers() {
  const token = localStorage.getItem("token");
  const userName = localStorage.getItem("userName");
  const [name, setName] = useState("Anya Forger");
  const [zip, setZip] = useState("9000");
  const [image, setImage] = useState(null);
  const userZipCode = localStorage.getItem("userZipCode");
  const [loading, setLoading] = useState(false);
  const [data2, setData2] = useState([]);
  const [records, setRecords] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const getOffers = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API}/MakeAnoffer/get-user-makeanoffer`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const json = await response.json();

        if (response.ok) {
          setData2(json.data || []);
          setRecords(json.data || []);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };

    getOffers();
  }, [token]);
  const ChatClick = () => {
    navigate("/user-auth/chat");
  };

  const setFilter = (value) => {
    const result = data2.filter((record) => {
      return (
        // record._id.toString().includes(value.toLowerCase()) ||
        record.houseAddress.toLowerCase().includes(value.toLowerCase()) ||
        record.houseZipCode
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
      );
    });

    setRecords(result);
  };
  const columns = [
    {
      name: "Tours",
      selector: (row) => row.houseAddress,
      cell: (row) => (
        <div className="table-layout-content-header-box">
          <div className="table-layout-content-header-image">
            <img
              src={
                row.houseImages.length > 0
                  ? row.houseImages[0]
                  : "/img/aqdas.jpeg"
              }
              className="table-layout-content-header-image-media img-fluid"
              alt=""
            />
          </div>
          <div className="table-layout-content-header-details">
            <h3 className="table-layout-content-header-details-name my-0">
              {row.houseAddress}
            </h3>
            <p className="table-layout-content-header-details-zipcode my-0">
              {row.houseZipCode}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      minWidth: "400px",
    },
    {
      name: "Date of Tour",
      selector: (row) => row.tourDateTime || "No Date",
      cell: (row) =>
        row.tourDateTime
          ? format(new Date(row.tourDateTime), "dd MMM, yyyy")
          : "No Date",
      sortable: true,
      minWidth: "130px",
    },
    {
      name: "Status",
      selector: (row) => row.tourStatus,
      cell: (row) =>
        row.tourStatus === "pending" ? (
          <div className="tour-status-pending-1">{row.tourStatus}</div>
        ) : (
          <div className="tour-status-completed-1">{row.tourStatus}</div>
        ),
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Action",
      cell: (row) =>
        row.tourStatus === "processing" ? (
          <button className="tour-cta-1" onClick={() => ChatClick()}>
            Chat
          </button>
        ) : (
          <button className="tour-cta-1">
            Chat
          </button>
        ),
      minWidth: "200px",
    },
  ];
  const customStyles = {
    table: {
      style: {
        backgroundColor: "#252525!important", // Light blue background for entire table
      },
    },
    headCells: {
      style: {
        backgroundColor: "#1e1e1e", // Header background color
        color: "#ffffff", // Header text color
        fontSize: "16px",

        // textTransform: "uppercase",
        fontFamily: "Degular-Light",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#ffffff", // Default text color
      },
    },
    rows: {
      style: {
        backgroundColor: "#252525", // Row background color
        fontFamily: "Degular-Light", // Custom font
      },
      highlightOnHoverStyle: {
        backgroundColor: "#e3f2fd", // Hover effect background color
        transition: "0.2s ease-in-out",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#1e1e1e",
        fontSize: "14px",
        borderTop: "1px solid #ddd",
        color: "#ffffff",
      },
      pageButtonsStyle: {
        color: "#ffffff", // Default text color of pagination buttons
        fill: "#ffffff", // Color for SVG icons
        "&:hover": {
          backgroundColor: "#252525", // Hover background
          color: "#ffffff", // Hover text color
          fill: "#ffffff",
        },
        "&:disabled": {
          color: "#bdbdbd", // Disabled color
          fill: "#bdbdbd",
        },
      },
    },
  };
  return (
    <div className="user-tour">
      {loading ? (
        <div className="wait-loader">
          <div className="spinner-grow text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="container-fluid px-0 d-flex w-100 justify-content-between align-items-center">
            <div className="row px-0 w-100">
              <div className="col-md-6 px-0">
                <h2 className="user-layout-page-heading">Your Offers</h2>
              </div>
              <div className="col-md-6 px-0 d-flex justify-content-end">
                <div className="input-group table-search-input-group d-flex justify-content-end align-items-center">
                  <img
                    src="/img/gold-search-icon.svg"
                    className="img-fluid table-search-icon"
                    alt=""
                  />
                  <input
                    type="text"
                    className="table-search-input"
                    placeholder="Search"
                    onChange={(e) => setFilter(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              {data2.length > 0 ? (
                // <div className="col-12 px-0 pt-4">
                //   <table className="table tour-table">
                //     <thead className="tour-table-head">
                //       <tr className="tour-table-row-head">
                //         <th className="tour-table-data-head-1" scope="col">
                //           Offers
                //         </th>
                //         <th className="tour-table-data-head" scope="col">
                //           Offer Date
                //         </th>
                //         <th className="tour-table-data-head" scope="col">
                //           Status
                //         </th>
                //         <th className="tour-table-data-head-last" scope="col">
                //           Action
                //         </th>
                //       </tr>
                //     </thead>
                //     <tbody className="tour-table-body">

                //       {
                //         data2.map((offer) => (
                //           <tr className="tour-table-body-row">
                //             <td className="tour-table-data-1">
                //               <div className="table-layout-content-header-box">
                //                 <div className="table-layout-content-header-image">
                //                   {offer.houseImages.length > 0 ? (
                //                     <img
                //                       src={offer.houseImages[0]}
                //                       className="table-layout-content-header-image-media img-fluid"
                //                       alt=""
                //                     />
                //                   ) : (
                //                     <>
                //                       <img
                //                         src="/img/aqdas.jpeg"
                //                         className="table-layout-content-header-image-media img-fluid"
                //                         alt=""
                //                       />
                //                     </>
                //                   )}
                //                 </div>
                //                 <div className="table-layout-content-header-details">
                //                   <h3 className="table-layout-content-header-details-name my-0">
                //                     {offer.houseAddress}
                //                   </h3>
                //                   <p className="table-layout-content-header-details-zipcode my-0">
                //                     {offer.houseZipCode}
                //                   </p>
                //                 </div>
                //               </div>
                //             </td>
                //             <td className="tour-table-data">
                //               <div className="tour-date">
                //                 {" "}
                //                 {offer.tourDateTime ? (
                //                   format(new Date(offer.tourDateTime), "dd MMM, yyyy")
                //                 ) : (
                //                   <span>null</span>
                //                 )}
                //               </div>
                //             </td>
                //             <td className="tour-table-data">
                //               {offer.tourStatus === "pending" ? (
                //                 <div className="tour-status-pending">
                //                   {offer.tourStatus}
                //                 </div>
                //               ) : (
                //                 <div className="tour-status-completed">
                //                   {offer.tourStatus}
                //                 </div>
                //               )}
                //             </td>
                //             <td className="tour-table-data-last">
                //               <button className="tour-cta">Chat</button>
                //             </td>
                //           </tr>
                //         ))}
                //     </tbody>
                //   </table>
                // </div>
                <div className="col-12 px-0 pt-4">
                  <DataTable
                    columns={columns}
                    data={records}
                    pagination
                    paginationPerPage={4} // Default rows per page
                    paginationRowsPerPageOptions={[4, 10, 15, 20]} // Available options
                    customStyles={customStyles}
                    progressPending={loading}
                    progressComponent={
                      <div className="text-center my-2 bg-white">
                        <div
                          className="spinner-border text-secondary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    }
                    // Add custom styles or classes here using Bootstrap classes
                    className="table table-striped table-hover"
                  />
                </div>
              ) : (
                <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
                  <img
                    src="/img/leadership-empty.svg"
                    className="img-fluid"
                    alt=""
                  />
                  <h2 className="leadership-empty-heading">It’s Empty here!</h2>
                  <p className="leadership-empty-para mt-2">
                    Look’s like you haven’t made any offer, To make a offer find
                    a property you like and make a offer!
                  </p>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default UserOffers;
